<template>
  <EModal
    :active="active"
    class="ad-pill-tooltip-modal"
    data-test-id="ad-pill-tooltip-modal"
    @close="onModalClose"
  >
    <div
      class="ad-pill-tooltip-modal__content"
      data-test-id="ad-pill-tooltip-modal__content"
    >
      <slot name="content" />
    </div>
  </EModal>
</template>

<script>
import EModal from '~~/common/vue/components/modal';

export default {
  name: 'EAdLabelModal',
  components: {
    EModal,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onModalClose() {
      this.$emit('close');
    },
  },
};

</script>

<style lang="scss">
.ad-pill-tooltip-modal__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
